import { Group } from '@types';

export function getUserGroup(id: string, userGroup?: Group[]) {
  return id ? userGroup?.find((group) => group.groupID === id)?.groupName : id;
}
